export const locale = {
    lang: 'en',
    data: {
        PROJECTS_SESSION_NEW_DIALOG_CREATE_SESSION: 'Add Workshop',
        PROJECTS_SESSION_NEW_DIALOG_GENERAL: 'General',
        PROJECTS_SESSION_NEW_DIALOG_MEMBERS: 'Members'
    }
};
